import * as React from "react";

export function createInternalComponent<P extends object>(
  component: React.FunctionComponent<P>
): React.FunctionComponent<P> {
  return component;
}
